// Only the transport's explicit products HTTP 404 + JSON false response emits
// this signal. Network failures and malformed responses must preserve ISR data.
export const catalogNotFound = Symbol('catalog-not-found')
